import { OnInit } from '@angular/core';
import { UtilService } from '@app/shared/utils';
var FooterComponent = /** @class */ (function () {
    function FooterComponent(util) {
        this.util = util;
    }
    Object.defineProperty(FooterComponent.prototype, "isFooter", {
        get: function () {
            var urls = ['motor-relatorio', 'gestao-de-caixa', 'boleta-upload', 'ocultacaocda'];
            var isUrl = urls.find(function (item) { return window.location.href.includes(item); });
            return !isUrl;
        },
        enumerable: true,
        configurable: true
    });
    FooterComponent.prototype.ngOnInit = function () {
        this.onResize();
    };
    FooterComponent.prototype.onResize = function (event) {
        this.calculateMinHeight();
        window.addEventListener('resize', function () {
            var offset = 218;
            var temporaryAdditionalOffset = 45;
            var height = window.innerHeight;
            var body = document.getElementsByClassName('page-container')[0];
            if (body) {
                var bodyHeight = body.getBoundingClientRect().height;
                if (height > bodyHeight) {
                    body.setAttribute('style', "min-height: " + (height + temporaryAdditionalOffset - offset) + "px;");
                }
            }
        }, false);
    };
    FooterComponent.prototype.calculateMinHeight = function () {
        var offset = 218;
        var temporaryAdditionalOffset = 45;
        var height = window.innerHeight;
        var body = document.getElementsByClassName('page-container')[0];
        if (body) {
            var bodyHeight = body.getBoundingClientRect().height;
            if (height > bodyHeight) {
                var disclaimerHeight = 75;
                var value = height + temporaryAdditionalOffset - offset;
                if (this.util.isHomePageOrBrowserWarning()) {
                    value = value - disclaimerHeight;
                }
                body.setAttribute('style', "min-height: " + value + "px");
            }
        }
    };
    FooterComponent.prototype.goToHeader = function () {
        this.util.requestFocus('headerArea');
        //this.util.requestFocus("itau_logo");
    };
    return FooterComponent;
}());
export { FooterComponent };
